export default __webpack_public_path__ + "static/media/franchises-icon4.3e7c35d7.svg";